import { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AuthContext } from '../App';

function Navbar() {
  const { user, logout } = useContext(AuthContext);
  const location = useLocation();

  return (
    <nav className="navbar">
      <div className="navbar-content">
        <Link to="/" className="logo">
          ZypeeTravel
        </Link>
        
        <div className="nav-links">
          <Link 
            to="/properties" 
            className={`nav-link ${location.pathname === '/properties' ? 'active' : ''}`}
          >
            Properties
          </Link>
          {user && (
            <>
              <Link 
                to="/dashboard" 
                className={`nav-link ${location.pathname === '/dashboard' ? 'active' : ''}`}
              >
                Dashboard
              </Link>
              <Link 
                to="/bookings" 
                className={`nav-link ${location.pathname === '/bookings' ? 'active' : ''}`}
              >
                My Bookings
              </Link>
              <Link 
                to="/reviews" 
                className={`nav-link ${location.pathname === '/reviews' ? 'active' : ''}`}
              >
                Reviews
              </Link>
              <Link 
                to="/loyalty" 
                className={`nav-link ${location.pathname === '/loyalty' ? 'active' : ''}`}
              >
                Loyalty
              </Link>
              <button 
                onClick={() => window.dispatchEvent(new CustomEvent('openChatbot'))}
                className="nav-link"
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#10b981',
                  cursor: 'pointer',
                  padding: '8px 12px',
                  fontWeight: '500'
                }}
              >
                💬 Support Chat
              </button>
            </>
          )}
          
          {!user && (
            <button 
              onClick={() => window.dispatchEvent(new CustomEvent('openChatbot'))}
              className="nav-link"
              style={{
                background: 'none',
                border: 'none',
                color: '#10b981',
                cursor: 'pointer',
                padding: '8px 12px',
                fontWeight: '500'
              }}
            >
              💬 Get Help
            </button>
          )}
        </div>

        <div className="auth-buttons">
          {user ? (
            <div className="user-menu">
              <div className="user-avatar" title={user.full_name}>
                {user.full_name.charAt(0).toUpperCase()}
              </div>
              <button onClick={logout} className="btn btn-outline" style={{ marginLeft: '12px' }}>
                Logout
              </button>
            </div>
          ) : (
            <>
              <Link to="/auth" className="btn btn-outline">
                Sign In
              </Link>
              <Link to="/auth" className="btn btn-primary">
                Get Started
              </Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}

export default Navbar;